import {
  ContractsModel,
  PostContractsModel,
} from '../../../library/src/contracts/models/ContractsModel';

export const GET_CONTRACTS = 'GET_CONTRACTS';
export interface GetContractsAction {
  type: typeof GET_CONTRACTS;
  payload: {
    campaign_year?: number;
  };
}

export const GET_CONTRACTS_SUCCESS = 'GET_CONTRACTS_SUCCESS';
export interface GetContractsSuccessAction {
  type: typeof GET_CONTRACTS_SUCCESS;
  payload: ContractsModel[];
}

export const POST_CONTRACTS = 'POST_CONTRACTS';
export interface PostContractsAction {
  type: typeof POST_CONTRACTS;
  payload: PostContractsModel;
}

export const POST_CONTRACTS_SUCCESS = 'POST_CONTRACTS_SUCCESS';
export interface PostContractsSuccessAction {
  type: typeof POST_CONTRACTS_SUCCESS;
  payload: ContractsModel[];
}
export const UPDATE_CONTRACTS = 'UPDATE_CONTRACTS';
export interface UpdateContractsAction {
  type: typeof UPDATE_CONTRACTS;
  payload: {
    id: number;
    contract: PostContractsModel;
  };
}

export const UPDATE_CONTRACTS_SUCCESS = 'UPDATE_CONTRACTS_SUCCESS';
export interface UpdateContractsSuccessAction {
  type: typeof UPDATE_CONTRACTS_SUCCESS;
}

export const DELETE_CONTRACTS = 'DELETE_CONTRACTS';
export interface DeleteContractsAction {
  type: typeof DELETE_CONTRACTS;
  payload: ContractsModel;
}

export const DELETE_CONTRACTS_SUCCESS = 'DELETE_CONTRACTS_SUCCESS';
export interface DeleteContractsSuccessAction {
  type: typeof DELETE_CONTRACTS_SUCCESS;
  payload: ContractsModel;
}

export const CANCEL_CONTRACTS_SUCCESS = 'CANCEL_CONTRACTS_SUCCESS';
export interface CancelContractsSuccessAction {
  type: typeof CANCEL_CONTRACTS_SUCCESS;
  payload: ContractsModel;
}

export const ON_SELECT_CONTRACT = 'ON_SELECT_CONTRACT';
export interface OnSelectContractAction {
  type: typeof ON_SELECT_CONTRACT;
  payload: ContractsModel | null;
}
export type SharedContractActionType =
  | GetContractsAction
  | GetContractsSuccessAction
  | OnSelectContractAction
  | PostContractsAction
  | PostContractsSuccessAction
  | UpdateContractsAction
  | UpdateContractsSuccessAction
  | DeleteContractsAction
  | DeleteContractsSuccessAction
  | CancelContractsSuccessAction;

export const sharedContractActions = {
  getContracts: (campaign_year?: number): GetContractsAction => {
    return {
      type: GET_CONTRACTS,
      payload: {
        campaign_year: campaign_year,
      },
    };
  },
  getContractsSuccess: (data: ContractsModel[]): GetContractsSuccessAction => {
    return {
      type: GET_CONTRACTS_SUCCESS,
      payload: data,
    };
  },
  onSelectContract: (
    contract: ContractsModel | null,
  ): OnSelectContractAction => {
    return {
      type: ON_SELECT_CONTRACT,
      payload: contract,
    };
  },
  postContracts: (data: PostContractsModel): PostContractsAction => {
    return {
      type: POST_CONTRACTS,
      payload: data,
    };
  },
  postContractsSuccess: (
    data: ContractsModel[],
  ): PostContractsSuccessAction => {
    return {
      type: POST_CONTRACTS_SUCCESS,
      payload: data,
    };
  },
  updateContract: (
    id: number,
    contract: PostContractsModel,
  ): UpdateContractsAction => {
    return {
      type: UPDATE_CONTRACTS,
      payload: {
        id: id,
        contract: contract,
      },
    };
  },
  updateContractsSuccess: (): UpdateContractsSuccessAction => {
    return {
      type: UPDATE_CONTRACTS_SUCCESS,
    };
  },

  deleteContract: (contract: ContractsModel): DeleteContractsAction => ({
    type: DELETE_CONTRACTS,
    payload: contract,
  }),

  deleteContractsSuccess: (
    data: ContractsModel,
  ): DeleteContractsSuccessAction => ({
    type: DELETE_CONTRACTS_SUCCESS,
    payload: data,
  }),

  cancelContractsSuccess: (
    data: ContractsModel,
  ): CancelContractsSuccessAction => ({
    type: CANCEL_CONTRACTS_SUCCESS,
    payload: data,
  }),
};

export default sharedContractActions;
